// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2mixB","input":"styles_input__2ksPb"};